// extracted by mini-css-extract-plugin
module.exports = {"body":"ClosePanel_body__pB8Yl"};